var map = {
	"./ar/label.json": 8479,
	"./ar/menu.json": 3200,
	"./ar/message.json": 9202,
	"./cz/label.json": 2457,
	"./cz/menu.json": 3006,
	"./cz/message.json": 868,
	"./de/label.json": 3367,
	"./de/menu.json": 6456,
	"./de/message.json": 5226,
	"./en/label.json": 3487,
	"./en/menu.json": 2048,
	"./en/message.json": 8290,
	"./es/label.json": 5824,
	"./es/menu.json": 3321,
	"./es/message.json": 7533,
	"./fr/label.json": 3864,
	"./fr/menu.json": 2561,
	"./fr/message.json": 5253,
	"./hr/label.json": 3850,
	"./hr/menu.json": 4143,
	"./hr/message.json": 6407,
	"./ja/label.json": 3069,
	"./ja/menu.json": 578,
	"./ja/message.json": 7200,
	"./ko/label.json": 8482,
	"./ko/menu.json": 8935,
	"./ko/message.json": 5519,
	"./kz/label.json": 9374,
	"./kz/menu.json": 6038,
	"./kz/message.json": 2748,
	"./pt/label.json": 8488,
	"./pt/menu.json": 8193,
	"./pt/message.json": 9477,
	"./sh/label.json": 1851,
	"./sh/menu.json": 5084,
	"./sh/message.json": 5974,
	"./sr/label.json": 9249,
	"./sr/menu.json": 6598,
	"./sr/message.json": 3004,
	"./sv/label.json": 2125,
	"./sv/menu.json": 5250,
	"./sv/message.json": 1824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3901;